import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.barogo_notice.";
export const autoLcBarogoNotice = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    list: {
        page_title: "바로고 공지사항",
        description: "바로고의 새로운 소식을 알려드립니다.",
        table: {
            id: "번호",
            title: "제목",
            created_time: "등록일",
        },
    },
    detail: {
        detail_view: "상세보기 (No. {id})",
    },
};
